<div
  class="pagination-container"
  *ngIf="pageItems.length > 0">

  <button
    class="btn-paginator"
    mat-mini-fab
    color="default"
    [disabled]="page === 1 || disabled"
    (click)="handleClickFirstPage()">
    <mat-icon>first_page</mat-icon>
  </button>

  <button
    class="btn-paginator"
    mat-mini-fab
    color="default"
    [disabled]="page === 1 || disabled"
    (click)="handleClickPreviousPage()">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <ng-container *ngIf="!hideNumberButtons">
    <ng-container *ngFor="let item of pageItems">
      <button
        type="button"
        class="btn-paginator"
        color="default"
        mat-mini-fab
        [disabled]="disabled"
        class="{{item.active?activeClass:''}}"
        (click)="handleClickPage(item.number)">
        {{ item.text }}
      </button>
    </ng-container>
  </ng-container>

  <button
    class="btn-paginator"
    color="default"
    mat-mini-fab
    [disabled]="page === totalPages || disabled"
    (click)="handleClickNextPage()">
    <mat-icon>chevron_right</mat-icon>
  </button>

  <button
    class="btn-paginator"
    color="default"
    mat-mini-fab
    [disabled]="page === totalPages || disabled"
    (click)="handleClickLastPage()">
    <mat-icon>last_page</mat-icon>
  </button>

</div>
